import { render, staticRenderFns } from "./checkPtClassTree.vue?vue&type=template&id=6e8c55ce&scoped=true&"
import script from "./checkPtClassTree.vue?vue&type=script&lang=js&"
export * from "./checkPtClassTree.vue?vue&type=script&lang=js&"
import style0 from "./checkPtClassTree.vue?vue&type=style&index=0&id=6e8c55ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8c55ce",
  null
  
)

component.options.__file = "checkPtClassTree.vue"
export default component.exports